import { lazy } from "react";
import AccessLevel from "../components/AccessLevel/AccessLevel";
import AddTicket from "../components/AddTicket/AddTicket";
import Meetingsummary from "../components/Meetingsummary/Meetingsummary";
import RollCall from "../components/RollCall/RollCall";
import SetPersonTarget from "../components/SetPersonTarget/SetPersonTarget";
import Targeting from "../components/Targeting/Targeting";
import Tickets from "../components/Tickets/Tickets";
import TicketsList from "../components/TicketsList/TicketsList";
import TicketsMenu from "../components/TicketsMenu/TicketsMenu";
import { DashboardManagement } from "../pages/DashboardManagement/DashboardManagement";
import ManagementSms from "../pages/ManagementSms/ManagementSms";
import ManagementSmsDetail from "../pages/ManagementSms/ManagementSmsDetail/ManagementSmsDetail";

export const ManagementRoute = [
  {
    path: "/",
    className: "dashboard",
    component: <DashboardManagement />,
  },
  {
    path: "/tickets",
    className: "ticketsList",
    component: <TicketsMenu />,
  },
  {
    path: "/Meetingsummary",
    className: "MeetingSummary",
    component: <Meetingsummary />,
  },
  {
    path: `/tickets/ticketChat/:id`,
    className: "ticketChat",
    component: <Tickets />,
  },

  {
    path: "/tickets/ticketsList",
    className: "tickets-list",
    component: <TicketsList />,
  },
  {
    path: "/tickets/addTicket",
    className: "add-ticket",
    component: <AddTicket />,
  },
  {
    path: "/RollCall",
    className: "roll-call",
    component: <RollCall />,
  },

  {
    path: "/Targeting",
    className: "targeting",
    component: <Targeting />,
  },

  {
    path: "/Targeting/target/:id",
    className: "persongTargetting",
    component: <SetPersonTarget />,
  },
  {
    path: "/manaegmentSms",
    className: "manaegmentSms",
    component: <ManagementSms />,
  },
  {
    path: "/manaegmentSms/:id",
    className: "manaegmentSms",
    component: <ManagementSmsDetail />,
  },
  {
    path: "/accessLevel",
    className: "accessLevel",
    component: <AccessLevel />,
  },
];
